import React, { useEffect } from 'react';
import { Route } from 'react-router';
import Head from './components/Head/Head';
import Flow from './components/Flow/Flow';
import {
  attachNavigationLock,
  detachNavigationLock
} from './preventNavigation';
import { useScrollToTop } from './hooks/useScrollToTop';

const App = () => {
  useEffect(() => {
    attachNavigationLock();
    return detachNavigationLock;
  });

  useScrollToTop();

  return (
    <div className="beacon-theme-modern-outlook">
      <Head />
      <Route component={Flow} />
    </div>
  );
};

export default App;
